import { queryAll, query, fromId } from '../utils/utils.js';
//adapted from https://www.advancedcustomfields.com/resources/google-map/

export class LocationBlockOrPage {
    root = query('body');

    constructor() {
		this.loadGoogleMapsApi();
    }

	loadGoogleMapsApi() {
		let local = this;
		let googleMapsApi = document.createElement("script");
		googleMapsApi.async = true;
		googleMapsApi.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + window.bhs.googleMapsApiKey + "&callback=Function.prototype");
		document.body.appendChild(googleMapsApi);
		googleMapsApi.addEventListener('load', function() {
			local.init();
		});
	}

    init() {
		let maps = this.root.querySelectorAll('.bhs-map');
		maps.forEach((map) => {
			this.initMap(map);
		});
	}

	initMap($el) {
		var $markers = $el.querySelectorAll('.marker');
		var mapArgs = {
			zoom        : parseInt($el.dataset.zoom || 16),
			mapTypeId   : google.maps.MapTypeId.ROADMAP
		};
		var map = new google.maps.Map( $el, mapArgs );

		map.markers = [];
		$markers.forEach((marker) => {
			this.initMarker(marker, map);
		});
		// $markers.each(function(){
		// });

		this.centerMap(map);
		return map;
	}

	initMarker( $marker, map ) {
		var lat = $marker.dataset.lat;
		var lng = $marker.dataset.lng;
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};

		var marker = new google.maps.Marker({
			position : latLng,
			map: map
		});

		map.markers.push( marker );
		// if( $marker.html() ){
		// 	// Create info window.
		// 	var infowindow = new google.maps.InfoWindow({
		// 		content: $marker.html()
		// 	});

		// 	// Show info window when marker is clicked.
		// 	google.maps.event.addListener(marker, 'click', function() {
		// 		infowindow.open( map, marker );
		// 	});
		// }
	}

	centerMap(map){
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );
		} else{
			map.fitBounds( bounds );
		}
	}
}
